import { Component, Vue } from 'vue-property-decorator'
// eslint-disable-next-line import/named
import { MetaInfo } from 'vue-meta'
import LinkItem from '~/types/LinkItem'
import PageHeader from '~/components/page/PageHeader'
import ImageElement from '~/components/element/ImageElement'
import dateToMonthStrFormat from '~/utils/dateToMonthStrFormat'
import loc from '~/utils/loc'
import s from '~/utils/s'
import mainBreadcrumbsSubmenuItems from '~/utils/mainBreadcrumbsSubmenuItems'
import ProductSlides from '~/components/block/ProductSlides'

@Component({
  head () {
    return s(this.$store).newsDetailPage.meta
  }
})
export default class NewsDetail extends Vue {
  get breadcrumb (): LinkItem[] {
    return [
      {
        title: 'Главная',
        location: loc(this.$store, {
          name: 'index'
        }),
        submenuItems: mainBreadcrumbsSubmenuItems(this.$store)
      },
      {
        title: 'Новости',
        location: loc(this.$store, { name: 'news' })
      },
      {
        title: s(this.$store).newsDetailPage.title,
        location: loc(this.$store, {
          name: 'news-code',
          params: {
            code: s(this.$store).newsDetailPage.code
          }
        })
      }
    ]
  }

  get date () {
    const date = s(this.$store).newsDetailPage.placementDate
    if (!date) {
      return ''
    }
    return dateToMonthStrFormat(new Date(date)) + 'г.'
  }

  get isProducts () {
    return s(this.$store).newsDetailPage.products && s(this.$store).newsDetailPage.products.length > 0
  }

  renderProducts () {
    if (this.isProducts) {
      return (
        <div class="product-page__col-analogs">
          <div class="product-page__analogs-products-container">
            <div class="product-page__analogs-products-items">
              <ProductSlides {...{
                props: {
                  products: s(this.$store).newsDetailPage.products,
                  title: 'Товары'
                }
              }} />
            </div>
          </div>
        </div>
      )
    }
  }

  render () {
    return (
      <div class="news-detail-page">
        <div class="news-detail-page__header">
          <PageHeader {...{
            props: {
              breadcrumb: this.breadcrumb
            }
          }} />
        </div>
        <div class="news-detail-page__container">
          <div class="news-detail-page__row">
            <div class="news-detail-page__col-content">
              <h1 class="news-detail-page__container-header">
                {s(this.$store).newsDetailPage.title}
              </h1>
              {s(this.$store).newsDetailPage.date &&
                <div class="news-detail-page__date">
                  {this.date}
                </div>
              }
              {s(this.$store).newsDetailPage.img &&
                <div class="news-detail-page__img">
                  <ImageElement {...{
                    props: {
                      img: s(this.$store).newsDetailPage.img
                    }
                  }} />
                </div>
              }
              {s(this.$store).newsDetailPage.HTMLContent &&
                <div class="news-detail-page__description">
                  <div class="custom-content" domPropsInnerHTML={s(this.$store).newsDetailPage.HTMLContent}></div>
                </div>
              }
            </div>
          </div>
        </div>
        <div class="product-page__other-products">
          {this.renderProducts()}
        </div>
      </div>
    )
  }
}
